export default "__VITE_ASSET__gbD78TdY__"